<ng-container *ngIf="loading$ | async">
  <div class="overlay"></div>
  <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
</ng-container>

<div class="page_bg">
  <div class="container-fluid custom-popup-style">
    <div class="col-xl-12 col-md-12 col-xs-12 text-black">
      <div class="card_thankyou">
        <div class="logo">
          <span class="h1 fw-bold mb-0"
            ><img src="/assets/images/GRlogo.png" alt="Logo" />
          </span>
        </div>
        <div class="mt-2 pt-2">
          <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
            <h5 class="pb-2 text-start text-uppercase custom-red">
              Registration
            </h5>

            <div
              *ngFor="let control of templateDetails"
              class="row form-outline mb-3"
            >
              <label [for]="control.columnName" class="col-4 mt-12 custom-label"
                >{{ control.columnDisplayName }}
                <span *ngIf="control.mandatory" class="red-text">*</span></label
              >

              <mat-form-field appearance="outline" class="col-8 mt-12">
                <ng-container
                  *ngIf="isDropdown(control.columnName); else textInput"
                >
                  <mat-select
                    *ngIf="control.columnName === 'redemptionCountry'"
                    [formControlName]="control.columnName"
                    [id]="control.columnName"
                    [placeholder]="control.columnDisplayName"
                  >
                    @for (country of countries; track country) {
                    <mat-option [value]="country.bocmCountryId">{{
                      country.bocmCountryName
                    }}</mat-option>
                    }
                  </mat-select>
                  <mat-select
                    *ngIf="control.columnName === 'paymentCurrency'"
                    [formControlName]="control.columnName"
                    [id]="control.columnName"
                    [placeholder]="control.columnDisplayName"
                  >
                    @for (currency of currencies; track currency) {
                    <mat-option [value]="currency.bocmCurrencyID">{{
                      currency.currencyCode
                    }}</mat-option>
                    }
                  </mat-select>
                </ng-container>
                <ng-template #textInput>
                  <input
                    matInput
                    [formControlName]="control.columnName"
                    [id]="control.columnName"
                    [placeholder]="control.columnDisplayName"
                  />
                </ng-template>
                <mat-error
                  *ngIf="
                    registrationForm
                      .get(control.columnName)
                      ?.hasError('required')
                  "
                >
                  {{ control.columnDisplayName }} is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <!-- <div>  -->

            <div class="d-grid gap-2 col-12 col-md-6 mx-auto custom-button">
              <button
                mat-raised-button
                type="submit"
                [disabled]="registrationForm.invalid"
                class="btn btn-primary custom-button-style"
              >
                Submit
              </button>
            </div>

            <br />
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
